module.exports = __webpack_public_path__ + "static/img/35-北京理工大学附属中学南校区.8c989b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/35-北京理工大学附属中学南校区.png
// module id = +BOe
// module chunks = 0